import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "who-maintains-this"
    }}>{`Who maintains this?`}</h3>
    <p>{`This is maintained by the community. If you have issues with it not functioning as intended, please `}<a parentName="p" {...{
        "href": "http://app.posthog.com/home#supportModal"
      }}>{`let us know`}</a>{`!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      